import Transactions from "@/components/layout/history/Transactions";

const History = () => {
  return (
    <div className="flex flex-col items-center gap-2 px-4 pt-4">
      <Transactions />
    </div>
  );
};

export default History;
